/**
 * Applies color to mobile browser frames.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
 */
export function themeColor(color?: string) {
  if (!color) return {};
  return {
    content: color,
    name: 'theme-color',
  };
}
